var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"select-button-wrapper"},[_c('button',{staticClass:"select-button",attrs:{"aria-controls":_vm.id},on:{"click":_vm.onSelectItem}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('ChevronRightIcon')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }